export default {
    address: {
        city: "Cidade",
        city_locality: "Cidade\/Localidade",
        country: "País",
        line1: "Endereço Linha 1",
        line2: "Linha de Endereço 2",
        postal_code: "Código Postal",
        state: "Estado",
        state_region: "Estado\/Região"
    },
    alerts: {
        account_2fa: "Proteja a sua conta com autenticação de dois fatores.",
        account_2fa_success: "A autenticação de dois fatores está ativada.",
        activate_instruction: "Ao ativar a recolha automática de avaliações, tentará solicitar uma avaliação de {count}. Pré-visualize os seus modelos antes de ativar.",
        activate_intro: "Solicite continuamente avaliações com base na sua estratégia.",
        agency_mcp_server: "Ligue o Claude ou qualquer cliente MCP ao servidor MCP da sua agência. Os assistentes autorizados podem gerir os projetos, clientes e pessoal da sua agência em seu nome.",
        agency_sso: "Ligue um fornecedor de identidade OpenID Connect para o login do cliente.",
        ai_assistant: "O nome e a descrição da sua empresa são necessários para utilizar a IA para sugestões de avaliação e respostas.",
        api_key_roll: "Tem a certeza que pretende alterar a sua chave API ? Isto afetará qualquer aplicação que a esteja a utilizar.",
        ask_confirm: "Tem a certeza que pretende solicitar avaliações de {count}? Isto agendará os pedidos para todos os clientes que ainda não foram consultados.",
        cname_delete: "Tem a certeza que pretende remover o CNAME: {cname_name}?",
        cname_not_configured: "Este registo ainda não foi configurado. Aguarde...",
        cname_warning: "As mensagens que já foram enviadas aos seus clientes terão links quebrados.",
        connection_disabled: "A ligação está desativada. Reconecte-se.",
        customer_archive: "Tem a certeza que pretende arquivar o cliente: {customer_name}? Todas as mensagens não enviadas serão canceladas.",
        customer_cancel: "Tem a certeza de que pretende cancelar todas as mensagens não enviadas para o cliente: {customer_name}?",
        customer_ingest: "Inclua este endereço de e-mail no campo BCC quando enviar e-mails aos seus clientes para que os seus nomes e endereços de e-mail sejam importados automaticamente.",
        customer_resubscribe: "Tem a certeza de que pretende voltar a inscrever o cliente: {customer_name}?",
        customer_unarchive: "Tem a certeza que pretende desarquivar o cliente: {customer_name}?",
        customer_unsubscribe: "Tem a certeza que pretende cancelar a subscrição do cliente: {customer_name}?",
        customer_unsubscribe_all: "Tem a certeza que pretende cancelar a subscrição de {count} para não receber mensagens deste projeto?",
        delete: "Tem a certeza que pretende eliminar {model}: {name}?",
        delete_count: "Tem a certeza que pretende eliminar {count}",
        domain_agency: "Adicione o seu próprio domínio de envio para tornar a sua agência totalmente white label.",
        domain_delete: "Tem a certeza que pretende remover o domínio: {name}? Continuaremos a enviar e-mails do nosso próprio domínio.",
        domain_dmarc: "Adicione um registo DMARC ao seu domínio para reduzir a probabilidade de os seus e-mails serem classificados como spam.",
        domain_project: "Adicione um domínio de envio para que possamos enviar e-mails aos seus clientes a partir do seu próprio nome de domínio.",
        export_confirm: "Tem a certeza de que pretende exportar todos os seus {model}?",
        export_count: "Tem a certeza que pretende exportar {count}?",
        export_link: "Um link para download será enviado para {email} logo após ter feito o pedido.",
        highlights_save_disabled: "Opcionalmente, pode remover os destaques de todas as avaliações que os tenham.",
        highlights_save_enabled: "Para destacar todas as avaliações positivas, assinale a caixa abaixo. Se estiver apenas a alterar a cor do destaque, deixe a caixa desmarcada.",
        integration_disconnect: "Tem a certeza de que pretende desligar do {integration_name}?",
        integration_sync: "Tem a certeza de que pretende sincronizar a sua conta {integration_name}? Importaremos os seus dados continuamente.",
        intro: "Pronto para receber mais avaliações positivas dos seus clientes? Importe os seus clientes para começar. Depois, solicite avaliações manualmente ou clique no botão Automatizar e deixe as avaliações chegarem.",
        logout: "Tem a certeza de que quer sair?",
        mcp_server: "Ligue o Claude ou qualquer cliente MCP a este projeto. O servidor MCP permite aos assistentes de IA ler e gerir avaliações, clientes e mensagens em seu nome.",
        member_confirm: "Tem a certeza de que deseja remover-se? Perderá o acesso a este projeto.",
        member_confirm_all: "Tem a certeza de que deseja remover-se? Perderá o acesso a todos os seus projetos.",
        member_other_confirm: "Tem a certeza que pretende remover {noun}: {name}? Vão perder o acesso a este projeto.",
        member_other_confirm_all: "Tem a certeza que pretende remover {noun} {name}? Perderão o acesso a todos os seus projetos.",
        message_cancel: "Tem a certeza que pretende cancelar esta mensagem?",
        message_cancel_all: "Tem a certeza que pretende cancelar {count}? Esta ação só pode ser realizada em mensagens não enviadas.",
        message_delete: "Tem a certeza que pretende eliminar esta mensagem?",
        oauth_client_revoke: "Tem a certeza que pretende revogar o acesso para {client}? Todas as sessões ativas serão desligadas imediatamente.",
        project_summary: "Não é possível gerar um resumo neste momento.",
        project_suspend: "Tem a certeza que pretende suspender o projeto: {project_name}?",
        project_unsuspend: "Tem a certeza que pretende reativar o projeto: {project_name}?",
        review_delete: "Tem a certeza de que pretende eliminar esta avaliação? Esta ação não pode ser anulada.",
        review_page_confirm: "Tem a certeza de que pretende guardar as suas alterações?",
        review_page_default: "Tem a certeza de que pretende tornar a página de avaliação: {name} a sua página predefinida? Esta página será utilizada se nenhuma outra página for atribuída a um pedido de avaliação.",
        review_page_delete: "Tem a certeza que pretende eliminar a página de avaliações: {name}? Todos os clientes que estão atualmente direcionados para esta página serão direcionados para a sua página predefinida.",
        review_page_delete_all: "Tem a certeza de que pretende eliminar {count}? A sua página de avaliação padrão não será eliminada.",
        review_page_fields: "Utilize campos para captar informações do cliente ao deixar uma avaliação. Adicione mais campos ao seu formulário e apresente-os condicionalmente quando os clientes selecionarem uma avaliação.",
        review_page_instructions: "Apresentar instruções diretamente acima do formulário após a seleção de uma nota.",
        review_page_location_picker: "Permita que os clientes selecionem qualquer local do seu projeto para a avaliação. Esta opção será pré-selecionada caso a página de avaliação seja apresentada para um local específico.",
        review_page_locations: "Selecione os locais que devem utilizar esta página de avaliação. Um local só pode ser atribuído a uma página de avaliação. Se um local não tiver uma página atribuída, utiliza a página de avaliação predefinida.",
        review_page_redirects: "Ignore o formulário após selecionar uma nota e redirecione para outro local. Também pode dividir o tráfego para vários sites, adicionando mais do que um redirecionamento para cada nota.",
        share_template_delete: "Tem a certeza de que pretende eliminar o modelo de partilha \"{name}\"? Esta ação não pode ser anulada.",
        smtp_remove: "Tem a certeza de que pretende remover a configuração SMTP do seu projeto? O seu domínio de envio retornará à configuração padrão.",
        smtp_setup: "Envie e-mails a partir do seu próprio servidor de e-mail. Introduza as suas credenciais SMTP . Se o seu servidor utilizar restrições de IP, adicione os seguintes IPs utilizados pelo nosso sistema à lista de permissões: {ips}.",
        space_delete: "Tem a certeza que pretende eliminar o espaço de trabalho: {name}? Todos os projetos dentro do mesmo serão eliminados.",
        tag_rule: "Adicione um termo positivo e a sua contraparte negativa. Se aplicável, utilizaremos a IA para marcar automaticamente a avaliação com um ou outro.",
        user_delete: "Tem a certeza que pretende eliminar a conta de utilizador de: {email}?",
        user_verify: "Para verificar o seu endereço de e-mail e ativar a sua conta, clique no link no e-mail enviado para: {email}.",
        widget_delete: "Tem a certeza que pretende eliminar o widget: {name}? O widget deixará de ser exibido em nenhum site.",
        widget_restore: "Tem a certeza que pretende restaurar as definições do widget: {name}? Apenas o design retornará aos valores padrão.",
        widgets_1: "Adicione este script ao corpo do seu website.",
        widgets_2: "O Mural de resenhas apresenta todas as suas resenhas numa grelha. Adicione este script onde pretende apresentar o widget.",
        widgets_3: "A Resenha em destaque apresenta uma única resenha em tamanho grande. Adicione este script onde pretende apresentar o widget."
    },
    billing_statuses: {
        active: "A sua subscrição está ativa.",
        canceled: "A sua subscrição foi cancelada. Por favor, atualize para continuar.",
        ending: "A sua assinatura termina em {date}.",
        trial: "O seu período de teste gratuito termina em {date}.",
        trial_expired: "O seu período de teste gratuito terminou. Faça o upgrade para continuar.",
        trial_expiring: "O seu período de teste gratuito está a terminar em breve. Faça o upgrade para continuar."
    },
    brands: {
        boost_space: "Boost.space",
        discord: "Discord",
        email: "E-mail",
        facebook: "Facebook",
        google: "Google",
        google_analytics: "Google Analytics",
        hubspot: "HubSpot",
        linkedin: "LinkedIn",
        make_com: "Make.com",
        messenger: "Mensageiro",
        pabbly: "Pabbly",
        recaptcha: "reCAPTCHA",
        reddit: "Reddit",
        slack: "Slack",
        stripe: "Stripe",
        threads: "Threads",
        twilio: "Twilio",
        whatsapp: "WhatsApp",
        x: "X",
        zapier: "Zapier"
    },
    captions: {
        add_sending_domain: "Adicione um domínio de envio para editar o seu endereço de e-mail:",
        agency_robots: "Permita que os motores de busca indexem o seu portal do cliente.",
        ai_business_description: "Uma descrição detalhada do seu negócio para ajudar a gerar sugestões de avaliações e respostas.",
        ai_business_name: "O nome da sua empresa.",
        ask_location: "O local a atribuir à resenha.",
        ask_review_page: "A página para capturar a resenha.",
        assign_tags: "Atribua etiquetas à avaliação.",
        csv_max_rows: "Até {count} Linhas",
        dashboard_configure_settings: "Configure as definições do seu projeto.",
        dashboard_import_customers: "Importe os seus clientes.",
        dashboard_preview_email_templates: "Pré-visualize os seus modelos de e-mail.",
        dashboard_preview_kiosk_page: "Pré-visualize a sua página do quiosque.",
        dashboard_preview_review_page: "Pré-visualize a sua página de avaliação.",
        dashboard_preview_showcase_page: "Pré-visualize a sua página de apresentação.",
        logo_height: "A altura do logótipo em e-mails e páginas.",
        meta_description: "Substituir a descrição da página.",
        meta_title: "Substituir o título da página.",
        mfa_password: "Introduza a palavra-passe da sua conta.",
        mfa_qr_code: "Digitalize o código QR com a sua aplicação autenticadora.",
        mfa_security_code: "Introduza o código do seu aplicativo autenticador.",
        override_ambassador: "Apresente um emblema nos e-mails, páginas e widgets dos seus clientes.",
        project_name: "O nome da sua empresa, marca ou website.",
        project_robots: "Permita que os motores de busca indexem as suas páginas de avaliação e as exibam.",
        setup_basics: "Defina quando e como pede avaliações aos clientes.",
        setup_business: "Diga-nos o nome pelo qual os clientes o conhecem.",
        setup_google: "Direcione os clientes para o seu perfil Google , responda a resenhas e importe as existentes. Pode ignorar esta etapa e fazê-la mais tarde.",
        setup_location_limit: "O seu período de avaliação inclui 1 local. Atualize quando quiser para sincronizar mais locais.",
        project_slug: "Utilizado em e-mails e links orientados para o cliente se um CNAME não estiver configurado.",
        review_page_copied_message: "Exibido após o envio de uma avaliação positiva.",
        review_page_email_address: "Receba as avaliações neste e-mail.",
        review_page_link_reveal_position: "Onde revelar os links.",
        review_page_link_revealer_label: "O rótulo para revelar os links.",
        review_page_link_revealer_rating: "Revele os links se o cliente selecionar esta nota ou uma superior, caso contrário, mostre um botão para os revelar.",
        review_page_native_reviews: "Permitir avaliações nesta plataforma.",
        review_page_rating_selection: "Guardar a nota antes de enviar uma avaliação.",
        review_page_success_button_link: "Se estiver em branco, o link padrão será para o site do seu projeto; caso contrário, para o domínio da página.",
        review_page_warning: "Impedir que os clientes deixem avaliações públicas pode fazer com que a sua empresa seja removida do registo.",
        review_reply_status: "Não podemos responder publicamente a esta avaliação. Em vez disso, contacte diretamente o autor da avaliação.",
        review_suggestions: "Ajude os clientes a escrever avaliações.",
        separate_with_commas: "Separe os múltiplos com vírgulas.",
        showcase_locations: "Limite a exibição a locais específicos.",
        showcase_review_length: "As Resenhas devem ter, pelo menos, este número de caracteres.",
        showcase_since: "Mostrar avaliações criadas nesta data ou antes dela.",
        showcase_sources: "Limite a apresentação a fontes específicas.",
        showcase_tags: "Limite a apresentação a avaliações com etiquetas específicas.",
        signature_html: "Copie e cole a assinatura na sua aplicação de e-mail.",
        signed_up: "Data de início do cliente.",
        twilio_webhook: "Defina como URL de retorno para o seu serviço de mensagens.",
        widget_embed: "O atributo ID do contentor div onde o widget será apresentado."
    },
    labels: {
        accept_all: "Aceitar tudo",
        access_code: "Código de acesso",
        access_codes: "Códigos de acesso",
        account: "Conta",
        account_sid: "SID da conta",
        action: "Ação",
        actions: "Ações",
        activate: "Ativar",
        active: "Ativo",
        active_subscription: "Subscrição ativa",
        add: "Adicionar",
        add_agency_project: "Adicionar um projeto de agência",
        add_confirmation_message: "Adicione uma mensagem de confirmação.",
        add_css_rules: "Adicione as suas próprias regras css.",
        add_custom_field: "Adicionar campo personalizado",
        add_customer: "Adicionar um cliente",
        add_customers_with: "Adicionar clientes com {model}",
        add_external_link: "Adicionar um Link externo",
        add_external_links: "Adicionar Links externos",
        add_introduction: "Adicione uma introdução.",
        add_js_tags: "Adicione as suas próprias tags JavaScript .",
        add_legal_information: "Adicione informações legais.",
        add_location: "Adicionar um local",
        add_project: "Adicionar um projeto",
        add_review: "Adicionar uma Resenha",
        add_source: "Adicionar uma fonte",
        add_tag: "Adicionar uma Etiqueta",
        added: "Adicionado",
        address: "Morada",
        advanced_review_pages: "Páginas de Avaliação avançadas",
        affiliates: "Afiliados",
        age_of_reviews: "Idade das Resenhas",
        agencies: "Agências",
        agency: "Agência",
        agency_name: "Nome da agência",
        agency_project: "Projeto Agência",
        agency_projects: "Projetos de Agência",
        ai: "IA",
        ai_answers: "Respostas de IA",
        ai_assistant: "Assistente de IA",
        ai_auto_tagging: "Etiquetagem automática por IA",
        ai_reviews_and_replies: "Sugestões e respostas de IA para avaliações",
        ai_tagging_instructions: "Exemplo: Aplique a avaliações que mencionem tempos de espera, serviço lento ou atrasos.",
        all: "Tudo",
        allowed_domains: "Domínios permitidos",
        amount: "Montante",
        analytics: "Análise",
        and: "e",
        anonymous_reviews: "Resenhas anónimas",
        answer: "Resposta",
        any: "Qualquer",
        api: "API",
        api_key: "Chave API",
        appearance: "Aspeto",
        approved: "Aprovado",
        archive: "Arquivo",
        archive_customer: "Arquivar cliente",
        archived: "Arquivado",
        at_least: "pelo menos",
        at_least_days: "Pelo menos {num} dias",
        at_least_hours: "Pelo menos {num} horas",
        at_least_months: "Pelo menos {num} meses",
        at_most: "no máximo",
        at_most_days: "No máximo {num} dias",
        at_most_hours: "No máximo {num} horas",
        at_most_months: "No máximo {num} meses",
        auth_token: "Token de autenticação",
        authorize: "Autorizar",
        auto_detect: "Detecção automática",
        auto_tags: "Etiquetas automáticas",
        automate: "Automatizar",
        automate_highlights: "Automatizar destaques",
        automate_replies: "Respostas automáticas",
        automatic_review_collection: "Recolha Automática de Resenha",
        automatically_apply_tags: "Aplicar automaticamente a etiqueta às avaliações existentes.",
        automating: "A automatizar",
        avatar: "Avatar",
        avatars: "Avatares",
        average_charge: "Cobrança média",
        average_review: "Resenha média",
        background_color: "Cor de fundo",
        background_image: "Imagem de fundo",
        back: "Costas",
        bcc: "BCC",
        bcc_email_address: "Endereço de e-mail BCC",
        best_to_worst: "Do melhor para o pior",
        billing: "Cobrança",
        blog: "Blogue",
        body: "Conteúdo",
        body_font_size: "Tamanho da fonte do conteúdo",
        bold: "Negrito",
        book_a_demo: "Agendar uma demo",
        bottom: "Fundo",
        bottom_left: "Canto inferior esquerdo",
        bottom_right: "Canto inferior direito",
        build_on: "Construído em {model}",
        business: "Business",
        business_description: "Descrição do negócio",
        business_email: "Endereço de e-mail de suporte",
        business_name: "Nome da empresa",
        business_phone: "Número de telefone de apoio",
        business_website: "Site de negócios",
        button: "Botão",
        button_label: "Etiqueta para Botão",
        button_link: "Link para o Botão",
        button_position: "Posição do Botão",
        button_size: "Tamanho do Botão",
        buy_me_a_coffee: "Compre-me um café",
        by: "por",
        by_signing_up: "Ao criar uma conta, concorda com os nossos termos.",
        call_to_action: "Apelo à ação",
        cancel: "Cancelar",
        cancel_1_message: "Cancelar 1 mensagem",
        cancel_message: "Cancelar mensagem",
        cancel_messages: "Cancelar mensagens {count}",
        cancel_subscription: "Cancelar subscrição",
        cancel_unsent_messages: "Cancelar mensagens não enviadas",
        canceled: "Cancelado",
        center: "Centro",
        change: "Mudar",
        change_key: "Alterar a sua chave API",
        change_plan: "Plano de Mudança",
        changelog: "Registo de alterações",
        channel: "Canal",
        channels: "Canais",
        characters: "Caracteres",
        charges_avg: "A cobrança média deve ser de pelo menos",
        charges_count: "O número de cobranças deve ser, no mínimo,",
        charges_sum: "O total das cobranças deve ser de pelo menos",
        chat_with_us: "Fale connosco",
        checkbox: "Caixa de seleção",
        claude: "Claude",
        clear: "Claro",
        clear_highlights_from_reviews: "Remover os destaques de todas as avaliações",
        clicked: "Clicado",
        client: "Cliente",
        client_id: "ID do Cliente",
        clients: "Clientes",
        close: "Perto",
        cloudflare_warning: "Se utilizar o Cloudflare, o seu proxy deverá estar desativado.",
        cname: "CNAME",
        cname_setup_incomplete: null,
        cname_ssl_pending: "Aguarda certificado SSL",
        cname_status_for: "Estado CNAME para",
        code_editor: "Editor de código",
        collapse: "Recolher",
        collect_reviews_anywhere: "Recolher avaliações em qualquer lugar",
        color: "Cor",
        colors: "Cores",
        commission_rate: "Taxa de comissão",
        commission_status_approved: "Aprovado",
        commission_status_paid: "Pago",
        commission_status_pending: "Pendente",
        commission_status_reversed: "Invertido",
        community: "Comunidade",
        company: "Companhia",
        complained: "Reclamado",
        confirm_new_password: "Confirmar nova palavra-passe",
        confirmation_message: "Mensagem de confirmação",
        connect: "Ligar",
        connect_bank: "Ligar conta bancária",
        connect_google: "Ligar o Google",
        connect_google_business_profile: "Connect Google Business Profile",
        connected: "Conectado",
        consent_preferences: "Preferências de consentimento",
        contact_customer: "Contacto com o cliente",
        contact_support: "Por favor, contacte o suporte.",
        contact_us: "Contate-nos",
        container_element: "Elemento de contentor",
        context: "Contexto",
        continue: "Continuar",
        continue_with_google: "Continuar com o Google",
        cookie_category_analytics: "Análises",
        cookie_category_essential: "Essencial",
        cookie_category_functional: "Funcional",
        cookie_category_marketing: "Marketing",
        cookie_consent_banner: "Banner de consentimento de cookies",
        cookie_consent_scope_all: "Mostre a todos",
        cookie_consent_scope_eea: "Exposição exclusiva para visitantes do EEE e do Reino Unido.",
        cookie_consent_scope_none: "Não mostrar",
        cookie_policy: "Política de Cookies",
        cookie_preference: "Preferência de cookies",
        copied: "Copiado",
        copied_message: "Mensagem copiada",
        copy: "Cópia",
        copy_embed_code: "Copiar código de incorporação",
        copy_signature: "Copiar assinatura",
        copy_source_code: "Copiar código-fonte",
        copy_uuid: "Copiar UUID",
        create: "Criar",
        create_account: "Criar uma conta",
        create_agency: "Criar uma Agência",
        create_cname: "Crie um registo CNAME e aponte-o para",
        create_external_link: "Criar um Link externo",
        create_field: "Criar um campo",
        create_link: "Criar um Link",
        create_location: "Criar um local",
        create_project: "Criar um projeto",
        create_qr_code: "Criar código QR",
        create_review: "Criar uma Resenha",
        create_review_page: "Criar uma Página de Avaliação",
        create_signature: "Criar uma assinatura",
        create_source: "Criar uma fonte",
        create_space: "Criar um espaço de trabalho",
        create_tag: "Criar uma Etiqueta",
        create_tag_rule: "Criar uma regra de Etiqueta",
        create_webhook: "Criar um Webhook",
        create_widget: "Criar um widget",
        crms: "CRMs",
        csv: "CSV",
        currency: "Moeda",
        current_plan: "Plano atual",
        current_year: "Ano atual",
        custom_field: "Campo personalizado",
        custom_instructions: "Instruções personalizadas",
        custom_url: "URL personalizada",
        customer: "Cliente",
        customer_name_convention: "Convenção de Nome do Cliente",
        customer_reviews: "Resenhas de clientes",
        customers: "Clientes",
        customize: "Personalizar",
        customize_review_page: "Personalizar Página de Avaliação",
        daily: "Diariamente",
        daily_email_requests: "Pedidos diários de e-mail",
        daily_limit: "Limite Diário",
        daily_requests: "Pedidos diários",
        daily_sms_requests: "Pedidos diários de SMS",
        dark: "Escuro",
        dashboard: "Painel de controlo",
        date: "Data",
        date_added: "Data adicionada",
        date_canceled: "Data cancelada",
        date_clicked: "Data clicada",
        date_complained: "Data da reclamação",
        date_delivered: "Data de entrega",
        date_failed: "Data Falhou",
        date_messaged: "Data da mensagem",
        date_opened: "Data de abertura",
        date_replied: "Data da resposta",
        date_requested: "Data solicitada",
        date_reviewed: "Data da resenha",
        date_scheduled: "Data agendada",
        date_sent: "Data de envio",
        date_signed_up: "Data de inscrição",
        date_updated: "Data de atualização",
        dates: "Datas",
        day: "Dia",
        days: "Dias",
        days_after_last_request: "dias após o último pedido",
        days_later: "dias depois",
        deactivate: "Desativar",
        default: "Predefinição",
        default_language: "Idioma padrão",
        default_review_page: "Página de Avaliação padrão",
        default_review_visibility: "Visibilidade de Resenha padrão",
        default_tone: "Tom padrão",
        delay: "Atraso",
        delete: "Eliminar",
        delete_1_customer: "Apagar 1 cliente",
        delete_1_review: "Apagar 1 Resenha",
        delete_1_review_page: "Apagar 1 Página de resenha",
        delete_1_widget: "Apagar 1 widget",
        delete_agency: "Apagar Agência",
        delete_custom_field: "Apagar campo personalizado",
        delete_customer: "Apagar cliente",
        delete_customers: "Eliminar clientes",
        delete_external_link: "Apagar Link externo",
        delete_field: "Apagar campo",
        delete_link: "Apagar Link",
        delete_location: "Apagar local",
        delete_message: "Apagar mensagem",
        delete_n_customers: "Apagar clientes {count}",
        delete_n_review_pages: "Apagar Páginas de resenha {count}",
        delete_n_reviews: "Apagar Resenhas {count}",
        delete_n_widgets: "Apagar widgets {count}",
        delete_project: "Apagar projeto",
        delete_qr_code: "Apagar código QR",
        delete_reply: "Apagar resposta",
        delete_review: "Apagar Resenha",
        delete_review_page: "Apagar Página de Avaliação",
        delete_review_pages: "Apagar Páginas de Avaliação",
        delete_reviews: "Apagar Resenhas",
        delete_signature: "Apagar Assinatura",
        delete_source: "Apagar fonte",
        delete_space: "Apagar Espaço",
        delete_tag: "Apagar Etiqueta",
        delete_tag_rule: "Regra de exclusão de Etiqueta",
        delete_template: "Eliminar modelo",
        delete_user: "Apagar utilizador",
        delete_webhook: "Apagar Webhook",
        delete_widget: "Apagar widget",
        delete_widgets: "Apagar widgets",
        deleted: "Excluído",
        delivered: "Entregue",
        description: "Descrição",
        deselect_all: "Desmarcar tudo",
        disable: "Desativar",
        disable_automatic_review_collection: "Desativar a recolha automática de Resenha",
        disable_field: "Desativar campo",
        disable_when_links_are_visible: "Desativar quando os links estão visíveis",
        disabled: "Desativado",
        disconnect: "Desconectar",
        disconnect_integration: "Desconectar integração",
        discord_community: "Comunidade Discord",
        display_name: "Nome de exibição",
        dmarc: "DMARC",
        dmarc_status_for: "DMARC para",
        do_not_hide_from_public: "Não se esconda do público",
        do_not_send: "Não envie",
        documentation: "Documentação",
        domain: "Domínio",
        domain_name: "Nome de domínio",
        dont_have_an_account: "Não tem conta?",
        dont_send_thanks: "Não envie agradecimentos",
        download: "Transferir",
        download_records: "Baixar registos",
        download_template: "Baixar modelo",
        dpa: "DPA",
        dsar: "DSAR",
        duplicate: "Duplicado",
        duplicate_project: "Projeto duplicado",
        duplicate_review_page: "Página de Avaliação duplicada",
        duplicate_reviews: "Resenhas duplicadas",
        duplicate_widget: "Widget duplicado",
        edit: "Editar",
        edit_1_customer: "Editar 1 Cliente",
        edit_1_review: "Editar 1 Resenha",
        edit_client: "Editar Cliente",
        edit_custom_field: "Editar campo personalizado",
        edit_customer: "Editar Cliente",
        edit_customers: "Editar Clientes",
        edit_field: "Campo de edição",
        edit_link: "Editar Link",
        edit_location: "Editar localização",
        edit_member: "Editar membro",
        edit_n_customers: "Editar {count} Clientes",
        edit_n_reviews: "Editar Resenhas {count}",
        edit_notes: "Editar notas",
        edit_qr_code: "Editar código QR",
        edit_reviews: "Editar Resenhas",
        edit_signature: "Editar Assinatura",
        edit_source: "Editar código-fonte",
        edit_strategy: "Estratégia de edição",
        edit_tag: "Editar Etiqueta",
        edit_tag_rule: "Editar regra de Etiqueta",
        edit_team_member: "Membro da Equipa de Edição",
        edit_visibility: "Editar visibilidade",
        edit_webhook: "Editar Webhook",
        editable_ratings: "Classificações editáveis",
        earned: "Merecido",
        eligible: "Elegível",
        email: "E-mail",
        email_address: "Endereço de e-mail",
        email_validation_invalid: "Falha na validação do e-mail",
        email_validation_passed: "Validação de e-mail aprovada",
        email_validation_unknown: "O e-mail não pôde ser verificado",
        emails: "E-mails",
        embed_code: "Código de incorporação",
        enable: "Ativar",
        enable_automatic_review_collection: "Ativar a recolha automática de Resenha",
        enable_for_all_reviews: "Ativar para todas as avaliações",
        enable_for_positive_reviews: "Ativar avaliações positivas",
        enable_on_review_pages: "Ativar nas páginas de resenha",
        enabled: "Ativado",
        end: "Fim",
        ends: "Termina",
        exclude: "Excluir",
        exclude_email: "Apagar e-mail",
        exclude_sms: "Apagar SMS",
        excluded_channels: "Canais Excluídos",
        expand: "Expandir",
        expired: "Expirado",
        export: "Exportar",
        export_1_customer: "Exportar 1 cliente",
        export_1_review: "Exportar 1 Resenha",
        export_all: "Exportar tudo",
        export_all_customers: "Exportar todos os clientes",
        export_all_reviews: "Exportar todas as Resenhas",
        export_customers: "Clientes de exportação",
        export_n_customers: "Exportar clientes {count}",
        export_n_reviews: "Exportar {count} Resenhas",
        export_reviews: "Resenhas de exportação",
        external_link: "Link externo",
        external_links: "Links externos",
        extra_locations: "Locais extra",
        faces: "Rostos",
        failed: "Falhou",
        feedback: "Feedback",
        field: "Campo",
        fields: "Campos",
        filter: "Filtro",
        first: "Primeiro",
        first_charged: "Primeiro cobrado",
        first_name: "Nome próprio",
        first_name_last_initial: "Primeiro nome, última inicial",
        flag_as_duplicate: "Marcar como duplicado",
        font: "Fonte",
        font_family: "Família de fontes",
        font_size: "Tamanho da fonte",
        footer: "Rodapé",
        for: "Para",
        forgot_password: "Esqueceu-se da sua senha",
        form: "Forma",
        free: "Livre",
        free_requests_included: "Pedidos gratuitos incluídos",
        from: "de",
        full_name: "Nome completo",
        generate: "Gerar",
        generate_meta: "Gerar Meta",
        generate_qr_code: "Gerar código QR",
        generate_reply: "Gerar resposta",
        generate_review: "Gerar Resenha",
        generating: "A gerar",
        get_started: "Começar",
        get_started_checklist: "Lista de verificação para começar",
        get_the_lifetime_deal: "Obtenha o acordo vitalício",
        getting_started: "Começando",
        google_fonts: "Fontes do Google",
        grouped_by_request: "Agrupados por pedido",
        has_links: "Tem Links",
        has_notes: "Contém anotações",
        has_redirects: "Tem redireccionamentos",
        have_an_account: "Tem uma conta?",
        header: "Cabeçalho",
        hidden: "Oculto",
        hidden_from_search_engines: "Oculto dos motores de busca",
        hidden_reviews: "Resenhas ocultas",
        hide: "Ocultar",
        hide_all_reviews: "Ocultar todas as avaliações",
        hide_avatar: "Ocultar Avatar",
        hide_date: "Ocultar data",
        hide_drop_shadow: "Ocultar sombra projetada",
        hide_field_label: "Ocultar rótulo do campo",
        hide_from_public: "Ocultar do público",
        hide_name: "Ocultar nome",
        hide_pagination: "Ocultar paginação",
        highlight_color: "Cor de destaque",
        host: "Host",
        hours: "Horas",
        icon: "Ícone",
        icon_size: "Tamanho do ícone",
        icons: "Ícones",
        id: "ID",
        image: "Imagem",
        import: "Importação",
        import_address1: "Linha 1 do endereço do cliente.",
        import_address2: "Linha 2 da morada do cliente.",
        import_city: "A cidade ou localidade do cliente.",
        import_company: "Nome da empresa do cliente.",
        import_created_at: "A data da resenha.",
        import_customers: "Clientes de importação",
        import_email: "Endereço de e-mail do cliente.",
        import_first_name: "O primeiro nome do cliente.",
        import_from_boost_space: "Importar de Boost.space",
        import_from_facebook: "Importar do Facebook",
        import_from_google: "Importar do Google",
        import_from_hubspot: "Importar do HubSpot",
        import_from_make_com: "Importe de Make.com",
        import_from_pabbly: "Importado de Pabbly",
        import_from_stripe: "Importar do Stripe",
        import_from_zapier: "Importar do Zapier",
        import_last_name: "Apelido do cliente.",
        import_list: "Lista separada por vírgulas de",
        import_notes: "Notas apenas para uso interno.",
        import_phone: "O número de telefone do cliente.",
        import_postal_code: "O código postal do cliente.",
        import_recent_reviews: "Importar Resenhas recentes",
        import_review: "O texto da resenha.",
        import_reviews: "Resenhas de importação",
        import_score: "A nota de 1 a 5.",
        import_signed_up_at: "Data de início do cliente.",
        import_slug: "O slug ou UUID de um",
        import_state: "O estado ou região do cliente.",
        incentive: "Incentivo",
        include: "Incluir",
        include_sample_reviews: "Inclua exemplos de resenhas.",
        incoming_webhook_url: "URL do Webhook de entrada",
        inherit: "Herdar",
        initializing: "Inicializando",
        initials: "Iniciais",
        insert_variable: "Inserir variável",
        instructions: "Instruções",
        integration: "Integração",
        integrations: "Integrações",
        interval: "Intervalo",
        introduction: "Introdução",
        invite: "Convidar",
        invite_client: "Convidar Cliente",
        invite_failed: "Falha no convite",
        invite_member: "Convidar membro",
        invite_sent_to: "Convite enviado para",
        invite_team_member: "Convidar membro da equipa",
        invited: "Convidado",
        issuer_url: "URL do emissor",
        italic: "itálico",
        joined: "Ingressou",
        key: "Chave",
        keywords: "Palavras-chave",
        keywords_in_replies: "Palavras-chave nas respostas",
        keywords_in_reviews: "Palavras-chave em Resenhas",
        kiosk_page: "Página do quiosque",
        label: "Etiqueta",
        label_font_size: "Tamanho da fonte do rótulo",
        labels: "Etiquetas",
        language: "Idioma",
        languages: "Idiomas",
        large: "Grande",
        last_charged: "Última cobrança",
        last_name: "Último nome",
        layout: "Esquema",
        leave: "Ausência",
        leave_project: "Sair do projeto",
        leave_space: "Deixe Espaço de trabalho",
        left: "Esquerda",
        let_clients_sign_in_with_sso: "Permitir que os clientes iniciem sessão com SSO",
        less: "menos",
        lifecycle_stage: "Fase do ciclo de vida",
        lifetime_deal: "Oferta vitalícia",
        light: "Luz",
        limit: "Limite",
        limits: "Limites",
        link: "Link",
        link_color: "Cor do link",
        link_reveal_position: "Posição de revelação do Link",
        link_revealer_button: "Botão Revelador de Link",
        link_revealer_label: "Rótulo revelador de Link",
        link_revealer_rating: "Nota do revelador de Link",
        links: "Links",
        links_per_review_page: "Links por Página de Avaliação",
        list: "Lista",
        list_unsubscribe_headers: "Cabeçalhos de List-Unsubscribe",
        load_more: "Carregar mais",
        loading: "A carregar",
        location: "Localização",
        location_address: "Localização Endereço",
        location_name: "Nome do local",
        location_picker: "Seletor de localização",
        locations: "Locais",
        locations_limit: "Limite de Locais",
        log_in: "Iniciar sessão",
        log_out: "Sair",
        logo: "Logotipo",
        logo_height: "Altura do logótipo",
        long: "Longo",
        lowest_rating: "Nota mais baixa",
        ltd: "LTD",
        make_default: "Tornar padrão",
        manage: "Gerir",
        manage_limits: "Gerir Limites",
        manage_overrides: "Gerir substituições",
        manage_payout_account: "Gerir conta de pagamento",
        manage_subscription: "Gerir subscrição",
        manual_entry: "Entrada manual",
        max: "Máx.",
        max_size: "Tamanho máximo",
        maximum_characters: "Máximo de Caracteres",
        maximum_customers: "Máximo de clientes",
        maximum_locations: "Locais Máximos",
        maximum_members: "Membros Máximos",
        maximum_review_length: "Comprimento máximo da Resenha",
        maximum_tags: "Número máximo de Etiquetas",
        maximum_widgets: "Máximo de Widgets",
        mcp: "Servidor MCP",
        mcp_server: "Servidor MCP",
        mcp_server_url: "URL do Servidor MCP",
        medium: "Médio",
        member: "Membro",
        members: "Membros",
        menu: "Menu",
        message: "Mensagem",
        message_link_expiration: "Expiração do Link da mensagem",
        messaged: "Mensagem enviada",
        messages: "Mensagens",
        messages_clicked: "Mensagens clicadas",
        messages_sent: "Mensagens enviadas",
        messaging_service_sid: "SID do serviço de mensagens",
        min: "Mínimo",
        min_size: "Tamanho mínimo",
        minimal_delay: "Atraso mínimo",
        minimum_characters: "Caracteres mínimos",
        minutes: "Minutos",
        month: "mês",
        monthly: "Mensal",
        monthly_email_requests: "Pedidos mensais por e-mail",
        monthly_limit: "Limite Mensal",
        monthly_pricing_only: "Apenas preços mensais",
        monthly_request_limit: "Limite de requisição mensal",
        monthly_requests: "Pedidos mensais",
        monthly_sms_requests: "Pedidos mensais de SMS",
        months: "Meses",
        months_free: "{count} Meses grátis",
        more: "mais",
        more_clients: "mais clientes",
        more_customers: "mais clientes",
        more_options: "Mais opções",
        more_patients: "mais doentes",
        more_reviews: "Mais avaliações",
        more_reviews_needed: "Mais resenhas são necessárias para resumir",
        more_users: "mais utilizadores",
        more_visitors: "mais visitantes",
        move: "Mover",
        moved: "Movido",
        name: "Nome",
        native_reviews: "Resenhas Nativas",
        negative_term: "Termo Negativo",
        negative_trends: "Tendências Negativas",
        new: "Novo",
        new_password: "Nova Senha",
        no: "Não",
        no_available_options: "Nenhuma opção disponível",
        no_credit_card_required: "Não é necessário cartão de crédito",
        no_data_available: "Nenhum dado disponível",
        no_negative_trends: "Nenhuma tendência negativa ainda",
        no_positive_trends: "Nenhuma tendência positiva ainda",
        no_reminders: "Não envie lembretes",
        no_retries: "Sem novas tentativas",
        no_review: "Nenhuma resenha",
        none: "Nenhum",
        not_connected: "Não conectado",
        not_reviewed: "Não Resenhado",
        notes: "Notas",
        notifications: "Notificações",
        now: "Agora",
        number_of_charges: "Número de cobranças",
        number_of_reminders: "Número de lembretes",
        number_of_retries: "Número de tentativas",
        number_of_review_suggestions: "Número de sugestões de Resenha",
        of: "de",
        off: "Desligado",
        on: "Em",
        on_channel: "no canal {channel}.",
        opened: "Aberto",
        options: "Opções",
        or_log_in_with_email: "ou inicie sessão com o seu endereço de e-mail",
        or_sign_up_with_email: "ou utilize o seu endereço de e-mail",
        our_reviews: "As nossas resenhas",
        output: "Saída",
        page_footer: "Rodapé da página",
        paid: "Pago",
        paragraph: "Parágrafo",
        password: "Palavra-passe",
        past_month: "Mês Passado",
        past_months: "Últimos {inc} meses",
        past_week: "Semana Passada",
        past_year: "Ano Passado",
        past_years: "Últimos {inc} anos",
        paused: "Pausado",
        payment_method: "Método de pagamento",
        payout_status_completed: "Concluído",
        payout_status_pending: "Pendente",
        pending: "Pendente",
        pending_deployment: "Implantação pendente",
        pending_validation: "Validação pendente",
        per_day: "por dia",
        per_month: "por mês",
        permissions: "Permissões",
        phone: "Telefone",
        phone_number: "Número de telefone",
        pixels: "pixels",
        placeholder: "Espaço reservado",
        placement: "Colocação",
        plan: "Plano",
        plan_bullet1: "Remova a nossa marca nos e-mails, páginas e widgets",
        plan_bullet2: "Utilize o seu domínio para páginas orientadas para o cliente e envio de e-mails",
        plan_bullet3: "Personalize o produto com a marca branca para agências",
        please_rate_our_service: "Por favor, avalie o nosso serviço.",
        png: "PNG",
        policies: "Políticas",
        popular: "Popular",
        port: "Porta",
        position: "Posição",
        positive_only: "Somente Resenhas positivas",
        positive_term: "Termo Positivo",
        positive_trends: "Tendências Positivas",
        powered_by: "Distribuído por",
        preview: "Visualização",
        preview_kiosk_page: "Página de pré-visualização do quiosque",
        preview_review_page: "Página de Avaliação",
        price: "Preço",
        pricing: "Preços",
        primary_color: "Cor primária",
        priority: "Prioridade",
        privacy_policy: "política de Privacidade",
        proceed_to_dashboard: "Prosseguir para o painel",
        product: "Produto",
        profile: "Perfil",
        project: "Projeto",
        project_name: "Nome do Projeto",
        setup_ask_delay: "Quanto tempo devo esperar antes de pedir uma avaliação?",
        setup_reminders: "Quantos lembretes devo enviar?",
        project_paused: "Este projeto está em pausa.",
        project_suspended: "Este projeto encontra-se suspenso.",
        project_website: "Site do projeto",
        projects: "Projetos",
        projects_limit: "Limite de Projetos",
        publish: "Publicar",
        publish_changes: "Publicar as alterações em todas as outras páginas de resenha",
        published: "Publicado",
        purchase: "Compra",
        qr_code: "Código QR",
        qr_code_name_placeholder: "Mesa 1, Receção",
        qr_codes: "Códigos QR",
        quantity: "Quantidade",
        query: "Pergunta",
        quick_import: "Importação rápida",
        rating: "Nota",
        rating_order: "Ordem das notas",
        rating_out_of: "nota de",
        rating_save_all: "Guardar nota antes de cada resenha",
        rating_save_customer: "Guardar nota antes de uma avaliação do cliente",
        rating_save_never: "Nunca guardar a nota antes da resenha",
        rating_selection: "Seleção de nota",
        rating_selector: "Seletor de nota",
        ratings: "Classificações",
        read: "Ler",
        reapply_highlights_eligible: "Recupere os destaques com IA para todas as avaliações positivas.",
        reconnect: "Reconectar",
        redeem: "Resgatar",
        redirect_uri: "URI de redireccionamento",
        redirects: "Redirecionamentos",
        refer_and_earn: "Indique e ganhe",
        referral_billing_status_active: "Inscrito",
        referral_billing_status_canceled: "Cancelado",
        referral_billing_status_trial: "Teste",
        referral_billing_status_trial_expired: "Período de teste expirado",
        referral_billing_status_trial_expiring: "Período de teste a expirar",
        referral_program: "Termos do Programa de Indicação",
        referrals: "Encaminhamentos",
        refresh: "Atualizar",
        regenerate: "Regenerado",
        reject_all: "Rejeitar tudo",
        related_reviews: "Resenhas semelhantes",
        related_similarity: "Semelhança",
        remaining: "Restante",
        reminder: "Lembrete",
        reminders: "Lembretes",
        remove: "Remover",
        remove_client: "Remover Cliente",
        remove_cname: "Remover CNAME",
        remove_domain: "Remover domínio",
        remove_from_project: "Remover do projeto",
        remove_member: "Remover membro",
        remove_smtp_configuration: "Remover configuração SMTP",
        remove_team_member: "Remover membro da equipa",
        rename: "Renomear",
        rename_template: "Renomear modelo",
        renews: "Renova",
        replied: "Respondido",
        reply: "Resposta",
        reply_to: "Endereço de resposta",
        replying_on: "Respondendo em",
        request: "Pedido",
        request_date: "Data do pedido",
        request_review: "Solicitar uma Resenha",
        request_reviews: "Solicitar Resenhas",
        requested: "Solicitado",
        requested_review: "Resenha solicitada",
        requests: "Pedidos",
        requests_left_this_month: "pedidos restantes este mês",
        requests_remaining: "Solicitações restantes",
        require_field: "Campo obrigatório",
        require_subscription: "O cliente deve ter uma subscrição ativa",
        required: "Obrigatório",
        reschedule_message: "Reagendar mensagem",
        resend_invite: "Reenviar convite",
        reset_password: "Redefinir palavra-passe",
        restore: "Restaurar",
        restore_to_defaults: "Restaurar para os padrões",
        restore_widget: "Widget de restauração",
        resubscribe: "Inscrever-se novamente",
        resubscribe_customer: "Cliente que reativa a inscrição",
        resync: "Ressincronizar",
        resync_account: "Sincronizar novamente a conta",
        resync_now: "Sincronizar novamente agora",
        retries: "Tentativas repetidas",
        reveal_above_form: "Revelar o formulário acima",
        reveal_after_submission: "Revelar após o envio",
        reveal_below_form: "Revelar formulário abaixo",
        review: "Resenha",
        review_length: "Duração da Resenha",
        review_link: "Link para Resenha",
        review_missed: "Resenha Perdida",
        review_not_requested: "Resenha não solicitada",
        review_origin: "Esta resenha foi originada a partir do modelo",
        review_page: "Página de resenha",
        review_pages: "Páginas de resenha",
        review_requested: "Resenha solicitada",
        review_spotlight: "Resenha em destaque",
        review_suggestion: "Sugestão de Resenha",
        review_suggestions: "Sugestões de Resenha",
        review_text: "Texto de Resenha",
        review_wall: "Mural de resenhas",
        reviewed: "Resenhado",
        reviews: "Resenhas",
        reviews_ask: "Perguntar",
        reviews_query_failed: "Algo correu mal. Por favor, tente novamente.",
        reviews_query_placeholder: "Pesquise avaliações ou faça uma pergunta...",
        reviews_with_highlights: "Resenhas com Destaques",
        reviews_with_replies: "Resenhas com Respostas",
        reviews_without_replies: "Resenhas sem respostas",
        revoke: "Revogar",
        revoke_client: "Revogar aplicação",
        roadmap: "Roteiro",
        role: "Papel",
        sans_serif: "Sans Serif",
        save: "Guardar",
        save_preferences: "Guardar preferências",
        save_template: "Guardar modelo",
        save_template_as_new: "Guardar novo modelo",
        saved: "Guardado",
        schedule: "Horário",
        schedule_review_request: "Agendar pedido de resenha",
        scheduled: "Agendado",
        score: "Pontuação",
        search: "Pesquisa",
        second: "Segundo",
        secret_key: "Chave Secreta",
        sections: "Seções",
        security_code: "Código de segurança",
        select: "Selecionar",
        select_account: "Selecione uma conta",
        select_all: "Selecionar tudo",
        select_an_option: "Selecione uma opção",
        select_bulk_action: "Selecione Ação em Massa",
        select_csv_file: "Selecione o ficheiro CSV",
        select_date: "Selecione a data",
        select_field: "Selecione um campo",
        select_icon: "Selecione um ícone",
        select_location: "Selecione um local",
        select_plan: "Selecione um plano",
        select_review: "Selecione uma Resenha",
        select_source: "Selecione uma fonte",
        select_tag: "Selecione uma Etiqueta",
        selected: "Selecionado",
        send: "Enviar",
        send_1_reminder: "Enviar 1 lembrete",
        send_2_reminders: "Enviar 2 lembretes",
        send_3_reminders: "Enviar 3 lembretes",
        send_anytime: "Enviar a qualquer momento",
        send_between: "Enviar entre",
        send_message: "Enviar mensagem",
        send_retries: "Enviar {count} novas tentativas",
        send_retry: "Enviar {count} Tentar novamente",
        send_test: "Enviar um teste",
        send_thanks: "Enviar agradecimentos",
        sender_email_address: "Endereço de correio eletrónico do remetente",
        sender_id: "ID do remetente",
        sender_name: "Nome do remetente",
        sending_domain: "Domínio de envio",
        sent: "Enviado",
        sent_replies: "Respostas enviadas",
        serif: "Serif",
        settings: "Configurações",
        share: "Partilhar",
        share_link: "Partilhar Link",
        short: "Curto",
        show: "Espetáculo",
        show_1_suggestion: "Mostrar uma sugestão",
        show_100_results: "Mostrar 100 resultados",
        show_2_suggestions: "Mostrar duas sugestões",
        show_25_results: "Mostrar 25 resultados",
        show_3_suggestions: "Mostrar três sugestões",
        show_4_suggestions: "Mostrar quatro sugestões",
        show_5_suggestions: "Mostrar cinco sugestões",
        show_50_results: "Mostrar 50 resultados",
        show_all_reviews: "Mostrar todas as avaliações",
        show_arrows: "Mostrar setas",
        show_avatar: "Mostrar Avatar",
        show_cookie_consent_banner: "Mostrar banner de consentimento de cookies",
        show_date: "Data do espetáculo",
        show_dots: "Mostrar pontos",
        show_drop_shadow: "Mostrar sombra projetada",
        show_field: "Mostrar campo nas seguintes classificações",
        show_full: "Mostrar estrelas completas",
        show_photo: "Mostrar apenas a foto",
        show_positive_reviews: "Mostrar apenas avaliações positivas",
        show_to_public: "Mostrar ao público",
        showcase: "Showcase",
        showcase_page: "Página de apresentação",
        sign_up: "Inscrever-se",
        sign_up_for_free: "Registe-se gratuitamente",
        sign_up_with_email: "Registe-se com e-mail",
        sign_in_with_sso: "Entrar com SSO",
        sign_up_with_google: "Registe-se com o Google",
        signature: "Assinatura",
        signatures: "Assinaturas",
        signed_up: "Inscrito",
        since: "Desde",
        size: "Tamanho",
        skip: "Ignorar",
        slug: "Slug",
        small: "Pequeno",
        sms: "SMS",
        smtp_configuration: "Configuração SMTP",
        sort: "Ordenar",
        source: "Fonte",
        source_code: "Código-fonte",
        sources: "Fontes",
        space: "Espaço de trabalho",
        space_name: "Nome do Espaço",
        spaces: "Espaços de trabalho",
        split: "Divisão",
        sso: "SSO",
        star_color: "Cor da Estrela",
        stars: "Estrelas",
        start: "Iniciar",
        start_free_trial: "Comece o seu teste gratuito",
        start_getting_more_reviews: "Comece a receber mais Resenhas",
        status: "Estatuto",
        store_code: "Código da loja",
        strategy: "Estratégia",
        sub_processors: "Subprocessadores",
        subject: "Assunto",
        subscribe: "Inscrever-se",
        subscription: "Subscrição",
        success_page: "Página de Sucesso",
        suggestion: "Sugestão",
        suggestions: "Sugestões",
        summary: "Resumo",
        support: "Suporte",
        suspend: "Suspender",
        suspend_project: "Suspender o projeto",
        suspended: "Suspenso",
        svg: "SVG",
        switch_to_smtp_setup: "Mudar para a configuração SMTP",
        switch_to_standard_setup: "Mudar para a configuração padrão",
        symbol: "Símbolo",
        sync: "Sincronizar",
        sync_account: "Sincronizar conta",
        sync_now: "Sincronizar agora",
        sync_scheduled_time: "Sincronização programada {time}",
        synced_time: "Sincronizado {time}",
        system: "Sistema",
        system_fonts: "Fontes do sistema",
        tag: "Etiqueta",
        tag_1_customer: "Etiqueta 1 Cliente",
        tag_1_review: "Etiquetar 1 resenha",
        tag_customers: "Etiquetar clientes",
        tag_existing_reviews: "Etiqueta Resenhas existentes",
        tag_n_customers: "Etiqueta {count} Clientes",
        tag_n_reviews: "Resenhas da Etiqueta {count}",
        tag_reviews: "Etiquetar resenhas",
        tag_rule: "Regra de marcação",
        tag_with_ai: "Marcar com IA",
        tags: "Etiquetas",
        tags_for_customers: "Etiquetas para clientes",
        tags_for_reviews: "Etiquetas para Resenhas",
        team: "Equipa",
        team_member: "Membro da equipa",
        team_members: "Membros da equipa",
        template: "Modelo",
        templates: "Modelos",
        terms_of_service: "Termos de Serviço",
        test_template: "Modelo de teste",
        tests: "Testes",
        text: "Texto",
        text_alignment: "Alinhamento de texto",
        text_color: "Cor do texto",
        thank_you_messages: "Mensagens de agradecimento",
        thanks: "Obrigado",
        theme: "Tema",
        third: "Terceiro",
        time_zone: "Fuso horário",
        timeframe: "Prazo",
        title: "Título",
        tone: "Tom",
        top: "Topo",
        top_left: "Canto superior esquerdo",
        top_right: "Canto superior direito",
        total_charges: "Total de cobranças",
        total_reviews: "Total de Resenhas",
        trigger: "Gatilho",
        trigger_charged: "Enviar pedido após a cobrança",
        trigger_created: "Enviar pedido após o registo",
        try_free: "Experimente grátis",
        try_it_free: "Experimente grátis",
        type: "Tipo",
        types: "Tipos",
        unarchive: "Desarquivar",
        unarchive_customer: "Desarquivar cliente",
        underline: "Sublinhado",
        unflag_as_duplicate: "Desmarcar como duplicado",
        unknown: "Desconhecido",
        unlimited: "ilimitado",
        unnamed: "Sem nome",
        unpublish: "Despublicar",
        unpublished: "Não publicado",
        unreplied: "Sem resposta",
        unsent_messages: "Mensagens não enviadas",
        unsubscribe: "Cancelar inscrição",
        unsubscribe_customer: "Cancelar subscrição do cliente",
        unsubscribe_customers: "Clientes que cancelam a subscrição",
        unsubscribe_text: "Texto de cancelamento de inscrição",
        unsubscribed: "Cancelado",
        unsuspend: "Reativar",
        unsuspend_project: "Reativar projeto",
        unverified: "Não verificado",
        update: "Atualização",
        update_password: "Atualizar palavra-passe",
        update_plan: "Plano de atualização",
        update_share_template: "Atualizar modelo",
        updated: "Atualizado",
        updates: "Atualizações",
        upgrade: "Atualização",
        upgrade_for_more: "Atualize para mais",
        upgrade_to_use: "Por favor, atualize para utilizar este recurso",
        upload: "Carregar",
        upload_csv: "Carregar ficheiro CSV",
        upload_icon: "Carregar um ícone",
        url: "URL",
        use: "Uso",
        use_filters_for_aggregate: "Utilize filtros para agregação",
        user: "Usuário",
        user_id: "ID do utilizador",
        user_info: "Informações do utilizador",
        username: "Nome de utilizador",
        utc: "UTC",
        validate: "Validar",
        validate_customer_email: "Validar o e-mail do cliente",
        validation: "Validação",
        validations: "Validações",
        value: "Valor",
        verify: "Verificar",
        verify_email_address: "Verificar endereço de e-mail",
        view: "Ver",
        view_all: "Ver tudo",
        view_all_features: "Ver todos os recursos",
        view_available_fields: "Ver campos disponíveis",
        view_documentation: "Ver documentação",
        view_email_templates: "Ver modelos de e-mail",
        view_review_pages: "Ver Páginas de Avaliação",
        view_reviews: "Ver Resenhas",
        view_settings: "Configurações de visualização",
        view_setup_guide: "Consulte o guia de configuração.",
        view_showcase: "Ver Showcase",
        view_strategy: "Estratégia de visualização",
        visibility: "Visibilidade",
        visible: "Visível",
        visible_reviews: "Resenhas visíveis",
        visible_to_search_engines: "Visível para motores de busca",
        wait_between_reminders: "Aguarde entre lembretes",
        wait_period: "Período de espera",
        webhook: "Webhook",
        webhooks: "Webhooks",
        website: "Site",
        weekly: "Semanalmente",
        weeks: "Semanas",
        widget: "Widget",
        widgets: "Widgets",
        with_ai: "com IA",
        worst_to_best: "Do pior para o melhor",
        write: "Escrever",
        written_reviews: "Resenhas escritas",
        year: "ano",
        yearly: "Anual",
        yes: "Sim",
        your_referral_link: "O seu Link de indicação"
    },
    landing: {
        announcement: "Obtenha relatórios de reputação com o nosso servidor MCP",
        callout_1_subtitle: "Aceda a todos os recursos principais gratuitamente durante 7 dias. Sem necessidade de cartão de crédito. Comece a receber mais resenhas agora mesmo.",
        callout_1_title: "Teste grátis",
        callout_2_subtitle: "Importar clientes com Stripe, HubSpot, Zapier, upload de CSV , BCC de e-mail, API e muito mais.",
        callout_2_title: "Configuração rápida",
        callout_3_subtitle: "Você decide a quem enviar e quando. Enviamos pedidos de avaliação aos seus clientes diariamente.",
        callout_3_title: "Automático",
        callout_4_subtitle: "Capte o feedback negativo antes de pedir aos clientes que deixem resenhas públicas.",
        callout_4_title: "Encaminhamento de feedback",
        counter: "Junte-se a mais de 5.000 negócios locais de serviços",
        counter_agencies: "Usado por mais de 500 agências para gestão de avaliações",
        industries: {
            accountants: "Contabilistas",
            auto_repair: "Mecânicos de automóveis",
            chiropractors: "Quiropráticos",
            cleaning: "Empregados de limpeza",
            contractors: "Empreiteiros",
            dentists: "Dentistas",
            doctors: "Médicos",
            electricians: "Eletricistas",
            financial_advisors: "Consultores financeiros",
            hvac: "Técnicos de AVAC",
            insurance_brokers: "Corretores de seguros",
            landscapers: "Jardineiros",
            law_firms: "Advogados",
            locksmiths: "Serralheiros",
            mortgage_brokers: "Mediadores de crédito",
            optometrists: "Optometristas",
            pest_control: "Exterminadores",
            personal_trainers: "Personal trainers",
            physical_therapists: "Fisioterapeutas",
            plumbers: "Canalizadores",
            real_estate: "Agentes imobiliários",
            restaurants: "Donos de restaurantes",
            salons: "Cabeleireiros",
            self_storage: "Operadores de self-storage",
            spas: "Esteticistas",
            tour_guides: "Guias turísticos",
            veterinarians: "Veterinários"
        },
        industries_title: "Gestão de avaliações para negócios locais de serviços",
        agencies_screen_1_title: "Um portal que eles pensam que você criou",
        agencies_screen_2_title: "Controle o acesso por cliente",
        agencies_screen_3_title: "IA pela qual os clientes vão pagar",
        agencies_screen_4_title: "Escale em todos os clientes",
        subtitle: "Solicite avaliações em piloto automático. Obtenha mais avaliações de 5 estrelas. Posicione-se acima da concorrência.",
        title: "Gestão de reputação com IA para",
        title_phrases: {
            google_reviews: "obter mais avaliações no Google",
            autopilot: "pedir avaliações em piloto automático",
            suggested_by_chatgpt: "ser sugerido pelo ChatGPT"
        },
        title_agencies: "Transforme avaliações em",
        title_agencies_phrases: {
            branded_product: "um produto da sua marca",
            recurring_retainers: "retainers mensais recorrentes",
            revenue_stream: "uma nova fonte de receita",
        },
        title_agencies_feature_summary: "Tudo o que as agências precisam",
        title_feature_summary: "Tudo na caixa",
        title_mcp: "Pergunte à IA sobre a sua reputação",
        title_review_flow: "Transforme ótimas experiências em avaliações",
        subtitle_review_flow: "Peça avaliações automaticamente. Os clientes podem deixar uma avaliação pública a qualquer momento. O feedback privado é opcional.",
        subtitle_mcp: "Ligue o Claude, o ChatGPT e outros clientes MCP e pergunte sobre avaliações, locais e outreach em linguagem natural.",
        subtitle_feature_summary: "Recolha, apresentação, IA e integrações — prontos quando estiver.",
        subtitle_agencies_feature_summary: "Portal white label, acesso de clientes, escala e automatização sob a sua marca.",
        agencies_screen_1_subtitle: "Dê a cada cliente um portal que parece um produto que criou: o seu logótipo, as suas cores, o seu domínio. Depois empacote a gestão de avaliações como um serviço recorrente em que entram todos os meses. Não está a recomendar uma ferramenta. Está a entregar uma.",
        agencies_screen_2_subtitle: "Nem todos os clientes devem ter tudo. Convide equipas para projetos específicos, defina funções e substitua funcionalidades e limites por conta para que os seus pacotes correspondam à faturação. Faça upsell de acesso à medida que crescem, sem builds à medida para cada pacote.",
        agencies_screen_3_subtitle: "Não se limite a gerir avaliações. Dê aos clientes IA que redige respostas, etiqueta feedback e funciona com o Claude ou outros assistentes via servidor MCP do projeto. É uma capacidade moderna que as agências podem empacotar, fazer upsell e renovar — sem equipa de conteúdos para cada conta.",
        agencies_screen_4_subtitle: "Um lugar de agência. Dezenas de negócios. Execute recolha, respostas e relatórios em cada local de cliente a partir de um hub e aumente a margem ao adicionar contas. Assim as agências transformam reputação numa receita escalável, não num projeto pontual.",
        title_contact: "Como podemos ajudar?",
        title_faq: "Perguntas frequentes",
        title_footer: "Deixe de correr atrás de avaliações. Comece a conquistá-las.",
        title_ltd: "Pague uma vez e use para sempre com a nossa oferta vitalícia por tempo limitado",
        title_pricing: "Todas as funcionalidades. Preços simples.",
        title_reviews: "Veja por que somos classificados como #1 em gestão de avaliações"
    },
    plans: {
        agency: {
            agency_api: "API da Agência",
            branded_portal: "Portal do cliente personalizado",
            client_invites: "Convites, funções e substituições de Cliente",
            custom_domain: "Domínio de agência personalizada",
            everything_in_business: "Tudo no plano de negócios",
            locations_included: "5 locais incluídos",
            review_requests: "5.000 pedidos de avaliação por local por mês",
            sso: "Autenticação única (SSO)",
            support: "Suporte ao cliente dedicado",
            volume_pricing: "Preços por volume a partir de 49 USD\/mês"
        },
        business: {
            ai: "Respostas, insights e questões da IA.",
            api_mcp: "Servidor API e MCP",
            custom_domains: "Domínios personalizados para e-mail e páginas de avaliação",
            google_facebook: "Perfil da empresa no Google e Facebook",
            locations_included: "1 local incluído",
            review_requests: "{count} pedidos de revisão\/local\/mês",
            support: "Suporte ao cliente dedicado",
            unlimited_customers: "Clientes ilimitados",
            volume_pricing: "Preços por volume a partir de 99 dólares\/mês"
        },
        selectors: {
            agency_included: "Locais incluídos: {count}",
            agency_tier: "+{from}–{to} locais · {price}\/{month} cada",
            agency_tier_plus: "+{from}+ locais · {price}\/{month} cada",
            business_tier: "Locais {from}–{to} · {price}\/{month} cada",
            business_tier_plus: "{from}+ locais · {price}\/{month} cada"
        }
    },
    pricing: {
        faq_business_vs_agency_a: "O plano Business é para empresas que gerem a sua própria reputação — com preço por local e faturação mensal ou anual. O plano Agency é para agências e consultores que necessitam de um portal de clientes com marca própria, domínio personalizado, SSO para clientes, convites para clientes e configurações personalizadas por projeto. O plano Agency tem cobrança mensal e inclui 5 locais inicialmente.",
        faq_business_vs_agency_q: "Qual a diferença entre Empresa e Agência?",
        feature_sso_tooltip: "Permita que os clientes convidados iniciem sessão no seu portal com o seu fornecedor de identidade da empresa através do OpenID Connect (por exemplo, Auth0, Okta ou Azure AD)."
    },
    mcp_example_prompts: {
        labels: {
            add_customer_and_ask: "Adicione um cliente e solicite uma avaliação.",
            customers_to_ask: "Encontre clientes para solicitar avaliações.",
            location_leaderboard: "Comparar o desempenho da localização",
            outreach_health: "Auditar a saúde da entrega de pedidos",
            review_digest: "Resumo semanal",
            send_review_requests: "Envie pedidos de resenha em massa."
        },
        texts: {
            add_customer_and_ask: "Adicione um novo cliente utilizando os dados de contacto que eu lhe fornecer e, em seguida, agende um pedido de avaliação para o mesmo por e-mail com 2 lembretes.",
            customers_to_ask: "Liste até 50 clientes que nunca foram solicitados a deixar uma avaliação, ordenados por data de inscrição, do mais recente para o mais antigo. Ignore os clientes que cancelaram a subscrição. Inclua nome, e-mail e data de inscrição.",
            location_leaderboard: "Crie um ranking de 90 dias por localização com contagem de avaliações, nota média, percentagem de avaliações de 5 estrelas e tendência em comparação com os 90 dias anteriores. Classifique por nota e sinalize qualquer queda superior a 0,2 estrelas.",
            outreach_health: "Para as mensagens de correio eletrónico enviadas nos últimos 14 dias, por favor, introduza o total enviado, a taxa de entrega, a taxa de abertura, a taxa de cliques e a taxa de falhas. Sinalize quaisquer anomalias.",
            review_digest: "Resuma todas as avaliações dos últimos 7 dias. Inclua a quantidade, a nota média, a distribuição por fonte e localização, os 3 principais temas e as 3 principais preocupações.",
            send_review_requests: "Para os clientes que se registaram nos últimos 30 dias e ainda não foram contactados, agende um pedido de avaliação por e-mail com 2 lembretes. Mostre primeiro a lista e aguarde a minha confirmação."
        }
    },
    messages: {
        activated: "Ativado com sucesso.",
        archived: "Arquivado com sucesso.",
        canceled: "Cancelado com sucesso.",
        cannot_copy: "Não é possível copiar para a área de transferência",
        cname_active: "O estado CNAME está ativo.",
        cname_not_active: "O estado CNAME ainda não está ativo.",
        connected: "Ligado com sucesso.",
        cookie_banner_text: "Utilizamos cookies para melhorar a sua experiência. Pode personalizar as suas preferências ou aceitar todos.",
        cookie_category_analytics_desc: "Utilizados para medir o tráfego do site e a utilização dos produtos. Estes cookies ajudam-nos a entender como os visitantes usam o nosso site.",
        cookie_category_essential_desc: "Sempre ativos. Estes cookies são necessários para o funcionamento do site e não podem ser desativados.",
        cookie_category_functional_desc: "Ative recursos avançados, como o chat ao vivo. Estes cookies não o rastreiam para fins publicitários.",
        cookie_category_marketing_desc: "Utilizado para publicidade e medição de campanhas. Isto pode incluir pixels de anúncios e ferramentas de atribuição.",
        copied: "Copiado com sucesso.",
        created: "Criado com sucesso.",
        deactivated: "Desativado com sucesso.",
        deleted: "Eliminado com sucesso.",
        disconnected: "Desligado com sucesso.",
        duplicated: "Duplicado com sucesso.",
        error: "Algo correu mal. Por favor, tente novamente.",
        google_connect_failed: "Não foi possível ligar ao Google. Pode tentar novamente ou ignorar por enquanto.",
        oauth_consent_intro: "{client} está a solicitar permissão para aceder à sua conta.",
        oauth_request_missing: "O pedido de autorização OAuth está ausente ou expirou.",
        operation_connection_sync_failed: "A sincronização de {integration_name} falhou.",
        operation_connection_sync_progress: "Sincronizando {integration_name}…",
        operation_connection_sync_success: "Sincronização {integration_name} concluída.",
        operation_customer_import_failed: "A importação do Cliente falhou.",
        operation_customer_import_progress: "Importar clientes…",
        operation_customer_import_success: "Importação do Cliente concluída.",
        operation_review_import_failed: "A importação da Resenha falhou.",
        operation_review_import_progress: "Importando resenhas…",
        operation_review_import_success: "Resenha da importação concluída.",
        operation_review_scrape_failed: "A importação da avaliação recente falhou.",
        operation_review_scrape_progress: "Importando resenhas recentes…",
        operation_review_scrape_success: "Importação da avaliação recente concluída.",
        processed: "Processado com sucesso.",
        published: "Publicado com sucesso.",
        purchased: "Comprado com sucesso.",
        queued: "Agendado com sucesso.",
        refreshed: "Atualizado com sucesso.",
        removed: "Removido com sucesso.",
        resubscribed: "Subscrição restabelecida com sucesso.",
        revoked: "Revogado com sucesso.",
        saved: "guardado com sucesso.",
        scheduled: "Agendado com sucesso.",
        sent: "Enviado com sucesso.",
        started: "Iniciado com sucesso.",
        stopped: "Parado com sucesso.",
        sso_failed: "Não foi possível autorizar com SSO.",
        sso_invalid_callback: "Retorno de chamada SSO inválido.",
        sso_not_configured: "O SSO não está configurado.",
        sso_openid_config_failed: "Não foi possível carregar a configuração OpenID.",
        sso_token_exchange_failed: "Não foi possível concluir a troca de tokens SSO.",
        subscribed: "Inscrito com sucesso.",
        suspended: "Suspenso com sucesso.",
        synced: "Sincronizado com sucesso.",
        unarchived: "Desarquivado com sucesso.",
        unpublished: "Não publicado com sucesso.",
        unscheduled: "Desprogramado com sucesso.",
        unsubscribed: "Inscrição anulada com sucesso.",
        unsuspended: "Reativado com sucesso.",
        updated: "Atualizado com sucesso.",
        upgraded: "Atualizado com sucesso.",
        validated: "Validado com sucesso.",
        verified: "Verificado com sucesso."
    },
    notices: {
        agency: "Tem uma agência? Pode utilizar a marca branca do nosso produto para que os seus clientes vejam apenas a sua marca ao utilizar o serviço.",
        connected_apps: "As aplicações que ligar através do MCP aparecerão aqui.",
        connector: "Importe os seus clientes de milhares de aplicações com {brand}.",
        customer_messages: "Solicite uma resenha para agendar mensagens.",
        customer_reviews: "Solicite uma avaliação deste cliente.",
        customers: "Importe os seus clientes para que comecem a solicitar avaliações.",
        external_links: "Adicione links externos ao seu portal de cliente para ajudar a vender os seus serviços. Estes links serão apresentados aos seus clientes na barra lateral.",
        links: "Adicione botões à sua página para deixar avaliações em sites de terceiros.",
        locations: "Crie um local para que possa atribuir avaliações a vários locais.",
        ltd: "Desbloqueie o acesso vitalício com o seu código de acesso. Cada código inclui um número limitado de pedidos mensais, além de todas as funcionalidades. Os códigos são cumulativos. 3 códigos removem toda a nossa identidade visual e desbloqueiam as funcionalidades da agência. Insira o seu código de acesso abaixo.",
        mcp_example_prompts: "Após ligar ao servidor MCP , cole esta informação no seu assistente como ponto de partida.",
        messages: "Todas as solicitações e lembretes aparecerão aqui quando forem solicitadas avaliações dos seus clientes.",
        no_commissions: "Ainda não ganhou nenhuma comissão.",
        no_payouts: "Os pagamentos são enviados manualmente assim que o seu saldo aprovado atingir pelo menos 50,00 dólares e a sua conta bancária estiver ligada.",
        no_projects: "Ainda não lhe foi atribuído um projeto. Contacte o administrador para obter acesso.",
        no_referrals: "Ainda não indicou ninguém. Partilhe o seu link de indicação para começar.",
        qr_codes: "Crie códigos QR com cores, localizações e etiquetas personalizadas. Faça o download em formato SVG ou PNG.",
        referrals_share_subject: "O meu Gestor de Reputação de IA",
        referrals_share_text: "A minha arma secreta para conseguir avaliações de negócios: More Good Reviews. Gestão de reputação com IA que realmente funciona. Registe-se através do meu link:",
        review_pages: "O seu projeto pode ter várias páginas de avaliação para os seus clientes deixarem avaliações. Isto é útil para empresas com mais do que uma filial.",
        reviews: "Estamos a aguardar avaliações dos seus clientes.",
        showcase: "Estamos apenas a começar.",
        signatures: "Crie uma assinatura de e-mail para copiar e colar na sua aplicação de e-mail.",
        sources: "Crie uma fonte para que possa categorizar as suas avaliações.",
        tag_rules: "Crie uma regra para categorizar as suas avaliações automaticamente com IA.",
        tags: "Crie uma etiqueta para categorizar as suas avaliações e os seus clientes.",
        unauthorized: "Não tem permissão para aceder a esta página.",
        unsubscribed: "Agora cancelou a inscrição para receber pedidos de resenha.",
        webhooks: "Adicione webhooks para ser notificado sobre eventos da plataforma.",
        widgets: "Crie widgets para incorporar avaliações no seu website.",
        your_referral_link_text: "Partilhe o seu link para ganhar {rate}% de comissão recorrente em cada pagamento de clientes que recomendar. Os pagamentos são enviados manualmente assim que o seu saldo aprovado atingir pelo menos 50,00 dólares."
    },
    notification_types: {
        descriptions: {
            imports: "Enviado quando as importações estiverem concluídas.",
            new_reviews: "Enviado quando as avaliações forem recebidas.",
            sent_replies: "Enviado quando as avaliações são respondidas automaticamente.",
            weekly_reports: "Um resumo das atividades é enviado semanalmente."
        },
        names: {
            imports: "Importações",
            new_reviews: "Novas Resenhas",
            sent_replies: "Respostas enviadas",
            weekly_reports: "Relatórios Semanais"
        }
    },
    roles: {
        manager: "Gestor",
        operator: "Operador",
        owner: "Proprietário",
        super_admin: "Administrador",
        viewer: "Visualizador"
    },
    tasks: {
        automate: "Turn on automatic review requests and reminders. Each customer is contacted once, and can unsubscribe anytime.",
        customers: "Import customers with names and email or phone — manually, via Stripe, HubSpot, app connectors, the API, or by BCC’ing your project email on invoices.",
        google: "Connect Google Business Profile to import reviews, keep them in sync, and reply from here.",
        review_page: "Customize the page that captures reviews and can send customers to third-party sites — text, layout, fields, links, and redirects.",
        strategy: "Choose when customers are asked for reviews. We’ve set a simple default you can change anytime.",
        templates: "Edit the request and reminder emails customers receive. Both include one-click ratings, plus your logo and branding."
    },
    titles: {
        accept_invite: "Aceitar convite",
        accepting_invite: "Aceitando convite",
        access_denied: "Acesso negado",
        account: "Conta",
        actions: "Ações",
        add_custom_field: "Adicionar campo personalizado",
        add_ons: "Complementos",
        address: "Morada",
        agencies: "Agências",
        agency: "Agência",
        ai_assistant: "Assistente de IA",
        ai_highlights: "Destaques da IA",
        ai_replies: "Respostas de IA",
        ai_review_suggestions: "Sugestões de Resenha de IA",
        analytics: "Análise",
        api: "API",
        api_key: "Chave API",
        appearance: "Aspeto",
        application_connectors: "Conectores de Aplicações",
        attributes: "Atributos",
        authorize: "Autorizar",
        auto_tagging: "Marcação automática",
        automatic_review_collection: "Recolha Automática de Resenha",
        billing: "Cobrança",
        branding: "Marca",
        change_password: "Alterar a palavra-passe",
        clients: "Clientes",
        cname: "CNAME",
        conditions: "Condições",
        connected_apps: "Aplicativos Conectados",
        contact_us: "Contate-nos",
        cookie_policy: "Política de Cookies",
        cookie_preferences: "Preferências de cookies",
        copy: "Cópia",
        create_your_account: "Crie a sua conta",
        crms: "CRMs",
        css: "CSS",
        custom_field: "Campo personalizado",
        custom_fields: "Campos personalizados",
        custom_icons: "Ícones personalizados",
        customer: "Cliente",
        customer_facing_pages: "Páginas de atendimento ao cliente",
        customers: "Clientes",
        dashboard: "Painel de controlo",
        details: "Detalhes",
        dmarc: "DMARC",
        domain: "Domínio",
        dpa: "Acordo de Processamento de Dados",
        dsar: "Pedido de acesso do titular dos dados",
        email_address: "Endereço de e-mail",
        email_messages: "Mensagens de e-mail",
        email_settings: "Definições de e-mail",
        email_usage: "Utilização de e-mail",
        emails: "E-mails",
        embed_code: "Código de incorporação",
        examples: "Exemplos",
        export: "Exportar",
        external_link: "Link externo",
        external_link_num: "Link externo #{num}",
        external_links: "Links externos",
        field: "Campo",
        fields: "Campos",
        filters: "Filtros",
        form_fields: "Campos de formulário",
        got_access_code: "Tem um código de acesso?",
        how_it_works: "Como funciona",
        incentive: "Incentivo",
        instructions: "Instruções",
        integration: "Integração",
        integrations: "Integrações",
        javascript: "JavaScript",
        latest_reviews: "Últimas Resenhas",
        lifetime_deal: "Oferta vitalícia",
        limits: "Limites",
        link: "Link",
        links: "Links",
        location: "Localização",
        location_picker: "Seletor de localização",
        locations: "Locais",
        log_in: "Iniciar sessão",
        log_out: "Sair",
        make_default: "Tornar padrão",
        manage_limits: "Gerir Limites",
        manage_overrides: "Gerir substituições",
        manage_review: "Gerir Resenha",
        mcp_example_prompts: "Exemplos de perguntas",
        mcp_server: "Servidor MCP",
        message: "Mensagem",
        messages: "Mensagens",
        meta: "Meta",
        no_clients: "Nenhum cliente",
        no_commissions: "Sem comissões",
        no_connected_apps: "Nenhum aplicativo ligado",
        no_custom_fields: "Sem campos personalizados",
        no_customers: "Nenhum cliente",
        no_links: "Sem Links",
        no_locations: "Nenhum local",
        no_members: "Nenhum membro",
        no_messages: "Nenhuma mensagem",
        no_payouts: "Sem pagamentos",
        no_projects: "Nenhum Projeto",
        no_qr_codes: "Sem códigos QR",
        no_referrals: "Sem encaminhamentos",
        no_review_pages: "Nenhuma Páginas de Avaliação",
        no_reviews: "Nenhuma Resenhas",
        no_tags: "Sem Etiquetas",
        no_team_members: "Nenhum membro da equipa",
        no_template: "Sem modelo",
        no_widgets: "Sem widgets",
        notifications: "Notificações",
        options: "Opções",
        overview: "Visão geral",
        payment_method: "Método de pagamento",
        photo: "Fotografia",
        plans: "Planos",
        powered_by: "Distribuído por",
        pricing: "Preços",
        privacy_policy: "política de Privacidade",
        profile: "Perfil",
        project: "Projeto",
        project_limits: "Limites do Projeto",
        project_overrides: "Substituições de Projeto",
        projects: "Projetos",
        qr_code: "Código QR",
        qr_codes: "Códigos QR",
        ratings: "Classificações",
        redeem_access_code: "Resgatar código de acesso",
        redirecting: "Redirecionando",
        redirects: "Redirecionamentos",
        referrals_commissions: "Comissões",
        referrals_payouts: "Pagamentos",
        referral_program: "Termos do Programa de Indicação",
        reminders: "Lembretes",
        reply: "Resposta",
        request: "Pedido",
        request_options: "Opções de pedido",
        requests: "Solicitações",
        required: "Obrigatório",
        reschedule_message: "Reagendar mensagem",
        reset_password: "Redefinir palavra-passe",
        retries: "Tentativas repetidas",
        review: "Resenha",
        review_link: "Link para Resenha",
        review_page: "Página de resenha",
        review_pages: "Páginas de resenha",
        review_spotlight: "Resenha em destaque",
        review_suggestions: "Sugestões de Resenha",
        review_wall: "Mural de resenhas",
        reviewer: "Resenhista",
        reviews: "Resenhas",
        save_changes: "Guardar alterações",
        schedule: "Horário",
        scrape_a_website: "Extrair de um site",
        search_engines: "Motores de busca",
        sections: "Seções",
        select_csv_file: "Selecione o ficheiro CSV",
        select_project: "Selecionar um projeto",
        selecting_project: "Selecionando Projeto",
        sending_domain: "Domínio de envio",
        sending_limits: "Limites de Envio",
        settings: "Configurações",
        setup: "Configurar",
        setup_basics: "A sua estratégia de Pedido",
        setup_business: "Vamos começar",
        setup_google: "O seu perfil do Google My Business",
        setup_trusted: "Aprovado por mais de 5.000 empresas.",
        showcase: "Showcase",
        sign_up: "Inscrever-se",
        signature: "Assinatura",
        signatures: "Assinaturas",
        signing_in: "Fazendo login",
        single_sign_on: "Autenticação única",
        slug: "Slug",
        sms: "SMS",
        sms_messages: "Mensagens SMS",
        sms_usage: "Utilização de SMS",
        smtp_configuration: "Configuração SMTP",
        source: "Fonte",
        sources: "Fontes",
        space: "Espaço de trabalho",
        spaces: "Espaços de trabalho",
        stats: "Estatísticas",
        sub_processors: "Subprocessadores",
        success_page: "Página de Sucesso",
        summary: "Resumo",
        tag: "Etiqueta",
        tag_rule: "Regra de marcação",
        tags: "Etiquetas",
        team_members: "Membros da equipa",
        template: "Modelo",
        templates: "Modelos",
        terms_of_service: "Termos de Serviço",
        two_factor_authentication: "Autenticação de dois fatores",
        unable_to_complete_request: "Não foi possível concluir o pedido.",
        unique_review_link: "Link de Resenha exclusivo",
        unsent_messages: "Mensagens não enviadas",
        unsubscribe: "Cancelar inscrição",
        update_plan: "Plano de atualização",
        usage: "Uso",
        user: "Usuário",
        user_info: "Informações do utilizador",
        verify_email_address: "Verificar endereço de e-mail",
        verifying_email: "Verificando o e-mail",
        visibility: "Visibilidade",
        webhook: "Webhook",
        webhooks: "Webhooks",
        website: "Site",
        white_label_api: "API de marca branca",
        white_label_client_portal: "Portal do Cliente White Label",
        white_label_image_urls: "URLs de imagens de marca branca",
        white_label_sending_domain: "Domínio de Envio de Marca Branca",
        white_label_widget_tag: "Tag widget de marca branca",
        widget: "Widget",
        widget_num: "Widget #{num}",
        widgets: "Widgets",
        your_plan: "O Seu Plano"
    },
    tones: {
        apologetic: "Apologético",
        casual: "Casual",
        empathetic: "Empático",
        enthusiastic: "Entusiasmado",
        formal: "Formal",
        friendly: "Amigável",
        grateful: "Grato",
        humorous: "Bem humorado",
        informative: "Informativo"
    },
    widgets: {
        labels: {
            alignment: "Alinhamento",
            animation: "Animação",
            autoplay: "Reprodução automática",
            autoplay_delay: "Atraso de reprodução automática",
            avatar: "Avatar",
            background_color: "Cor de fundo",
            border: "Fronteira",
            border_color: "Cor da borda",
            border_radius: "Raio de Borda",
            border_width: "Largura da Borda",
            carousel: "Carrossel",
            colors: "Cores",
            company: "Companhia",
            customer: "Cliente",
            customer_position: "Posição do Cliente",
            date: "Data",
            delay: "Atraso",
            drop_shadow: "Sombra projetada",
            duration: "Duração",
            filters: "Filtros",
            font: "Fonte",
            font_emphasis: "Ênfase na fonte",
            font_family: "Família de fontes",
            font_size: "Tamanho da fonte",
            include_hidden: "Incluir Resenhas ocultas",
            layout: "Esquema",
            limit: "Resenhas por página",
            location_ids: "Locais",
            marquee: "Marquee",
            max_slides: "Diapositivos Máximos",
            max_width: "Largura Máxima",
            name_convention: "Nome",
            padding: "Preenchimento",
            pagination: "Paginação",
            quotes: "Citações",
            rating: "Nota",
            rating_round: "Arredondamento",
            rating_round_hundredth: "Centésimo mais próximo (4,94)",
            rating_round_tenth: "Décimo mais próximo (4,9)",
            review: "Resenha",
            review_chars: "Duração da Resenha",
            review_count: "Contagem de Resenha",
            review_id: "Resenha",
            review_ids: "Resenhas",
            review_ids_for_faces: "Resenhas para Faces",
            reviews: "Resenhas",
            schema: "Esquema",
            schema_name: "Nome da empresa",
            schema_type: "Tipo de negócio",
            score: "Nota mais baixa",
            show_on_mobile: "Mostrar no telemóvel",
            slider: "Controle deslizante",
            source: "Fonte",
            source_ids: "Fontes",
            source_position: "Posição da fonte",
            speed: "Velocidade",
            star_color: "Cor da estrela",
            star_display: "Exibição de estrelas",
            star_size: "Tamanho da estrela",
            star_spacing: "Star Spacing",
            star_style: "Star Style",
            star_style_classic: "Classic",
            star_style_sharp: "Sharp",
            tag_ids: "Etiquetas",
            take: "Número máximo de Resenhas",
            text_color: "Cor do texto",
            truncate: "Resumir Resenha",
            visible_slides: "Diapositivos visíveis",
            width: "Largura"
        },
        types: {
            badge: "Distintivo",
            carousel: "Carrossel",
            carousel_dynamic: "Carrossel Dinâmico",
            corner: "Canto",
            corner_dynamic: "Canto dinâmico",
            faces: "Rostos",
            headline: "Título",
            highlights: "Destaques",
            marquee: "Marquee",
            spotlight: "Destaque",
            wall: "Mural"
        }
    }
}